export const NAVIGATION_BAR_TITLE = "ADHARVA INSTITUTE OF COMMERCE";
export const NAVIGATION_BAR_BUTTON = "REGISTER";
export const NAVIGATION_LINKS = [
  {
    title: "home",
    linkTo: "/",
  },
  {
    title: "services",
    linkTo: "/services",
  },
  {
    title: "connect",
    linkTo: "/connect",
  },
  {
    title: "more",
    linkTo: "/more",
  },
];
